import { User } from '../contexts/UserContext';
import { userApi } from '../api/userApi';

/**
 * Get all available users for assignment (contacts)
 * Returns current user first, then other users
 */
export const getAvailableUsers = async (currentUser: User | null): Promise<User[]> => {
  if (!currentUser) return [];
  try {
    const contacts = await userApi.getContacts();
    // Filter out current user from others, then put current user first
    const otherUsers = contacts.filter(user => user.id !== currentUser.id);
    return [currentUser, ...otherUsers];
  } catch {
    // If contacts endpoint fails (404 or not implemented), just return current user
    return [currentUser];
  }
};

/**
 * Find user by email (from contacts)
 */
export const findUserByEmail = async (email: string, currentUser: User | null): Promise<User | undefined> => {
  if (!currentUser) return undefined;
  const contacts = await userApi.getContacts();
  return contacts.find((user: User) => user.email === email);
};

/**
 * Get user display name for assignee (async)
 */
export const getAssigneeDisplayName = async (assignedTo: string | null | undefined, currentUser: User | null): Promise<string> => {
  if (!assignedTo) return 'Unassigned';
  if (currentUser && assignedTo === currentUser.email) return 'Me';
  const user = await findUserByEmail(assignedTo, currentUser);
  return user ? user.name : assignedTo;
};
